import React from "react";

/**
 * @param {Object} props
 * @param {string} props.notesHistoryString
 * @returns {React.JSX.Element}
 */
export default function NotesHistory({ notesHistoryString }) {
  return (
    <div className="panel-body">
      <pre>{notesHistoryString}</pre>
    </div>
  );
}
